
const m = window.require("clamp");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
